import React from 'react';
import { Wrapper, Image } from './styles';

const defaultProps = {
    backgroundHeader: {
        BACKGROUND: '#ffffff',
        IMAGES: [],
    },
    children: null,
    headerStyles: null,
};

const ModalHeaderBackground = ({ backgroundHeader, headerStyles, children }) => {
    const { BACKGROUND, IMAGES } = backgroundHeader;

    return (
        <Wrapper styles={headerStyles} backgroundColor={BACKGROUND}>
            {IMAGES && IMAGES.map(({ backgroundImage, styles }) => (
                <Image key={backgroundImage} src={backgroundImage} styles={styles} />
            ))}
            {children}
        </Wrapper>
    );
};

ModalHeaderBackground.defaultProps = defaultProps;

export default ModalHeaderBackground;
